import * as React from "react";
import {
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

export interface ModalHeaderProps {
  title: React.ReactNode;
  /** Rendered visually hidden (sr-only) for accessibility / Radix aria-describedby. */
  description?: string;
  /** Escape hatch for one-off layout tweaks; appended after the canonical classes. */
  className?: string;
}

/**
 * Shared dark header bar for modals/dialogs. Provides the single canonical
 * header style so individual dialogs don't hand-roll (and drift) their own.
 */
export function ModalHeader({
  title,
  description,
  className,
}: ModalHeaderProps) {
  return (
    <DialogHeader
      className={cn(
        "space-y-0 rounded-t-lg bg-primary-900 px-6 py-4",
        className,
      )}
    >
      <DialogTitle className="text-base font-semibold text-white-primary">
        {title}
      </DialogTitle>
      {description ? (
        <DialogDescription className="sr-only">{description}</DialogDescription>
      ) : null}
    </DialogHeader>
  );
}
